export enum AgreementType {
    ALL,
    COMMON,
    ORDER,
  }
  